import Vue from 'vue'
import Component from 'vue-class-component'
import ArticleVue from './Article.vue'
import { ARTICLE_ID, ScriptContent } from '../../store/editor/components/state'
import { PreviewContentType } from './PreviewInterface'
import { Watch } from 'vue-property-decorator'
import { Getters } from '../../store/editor/components/helpers'
import loadScript from '../../misc/load-script'

// Vuex （$store） に格納された記事データをプレビューする。
// 記事を読み込んでからプレビューしたい場合は PreviewPage.vue を使うこと。

@Component({
  components: {
    'article-preview': ArticleVue
  },
  props: {
    previewContentType: {
      type: String,
      required: false,
      default: 'internal'
    }
  }
})
export default class PreviewVue extends Vue {
  readonly previewContentType?: PreviewContentType
  isMounted: boolean = false

  get articleId(): string {
    return ARTICLE_ID
  }

  get embedScripts(): ScriptContent[] {
    return Getters.embedScripts(this.$store)
  }

  mounted(): void {
    this.isMounted = true
    this.refreshScriptPool()
  }

  contentType(): string {
    return this.previewContentType || 'internal'
  }

  close(): void {
    this.$emit('close')
  }

  getScriptPool(): HTMLElement {
    return <HTMLElement>this.$refs.scriptPool
  }

  @Watch('embedScripts')
  refreshScriptPool(): void {
    // mounted() が呼ばれる前、記事データがロードされたときに embedScript の変更を検知して本メソッドが呼ばれる場合がある。
    // その場合、 pool が undefined になりエラーとなってしまうので、エラーを避ける。
    this.$nextTick().then(() => {
      setTimeout(() => {
        const pool = this.getScriptPool()
        if (pool) {
          loadScript(pool, this.embedScripts)
        }
      }, 100)
    })
  }
}
